<template>
  <div class="hcl-form-element-html" v-html="htmlContent"></div>
</template>

<script setup lang="ts">
interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined
})

const htmlContent = atob(props.dataField.value)
</script>

<style lang="scss" scoped>
.hcl-form-element-html {
  width: 100%;
}
</style>
